import { createApp } from "vue";
import App from "./popup/App";
import Laskuri from "./kalkkilaskuri/App";
import SellerLiftApp from "./sellerlift/SellerLiftApp";
import ProductPage from "./productpage/App";
import ProductPageHeader from "./productpage-header/App";
import store from "./store";
import {
  SET_ADDRESS,
  SET_CATEGORIES,
  SET_PRODUCTS,
  UPDATE_DISTANCE,
  UPDATE_ECO_FILTER,
  UPDATE_WINTER_FILTER,
} from "./store/constants";
import { createI18n } from "vue-i18n";
import { buildCategoryStructure, getCurrentLocale } from "@/shared/helpers";
import * as _debug from "debug";
const debug = _debug("soilfood:main");

const i18n = createI18n({
  legacy: false,
  locale: getCurrentLocale(),
  fallbackLocale: "fi",
  availableLocales: ["fi", "sv"],
  messages: {
    fi: {
      questionsTitle:
        "Hei! Heräsikö kysymyksiä tai haluatko tehdä tilauksen? Soita.",
      buttonTitle: "Alueesi myyjä",
      buttonTitleFactory: "Teollinen myynti",
    },
    sv: {
      questionsTitle:
        "Hej! Har du frågor eller vill du göra en beställning? Ring oss.",
      buttonTitle: "Tag kontakt",
      buttonTitleFactory: "Teollinen myynti",
    },
  },
});

store.subscribe((mutation) => {
  if (mutation.type === SET_ADDRESS)
    window.dispatchEvent(new Event("soilfood-address-change"));
});

// Clear out some console logging in production
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  window.console.log = function () {};
  console.debug = function () {};
  window.console.debug = function () {};
  console.time = function () {};
  window.console.time = function () {};
  console.timeEnd = function () {};
  window.console.timeEnd = function () {};
}

if (process.env.NODE_ENV === "development") {
  localStorage.setItem("debug", "soilfood:*");
}

// Oma myyjä popup mounting logic
if (document.getElementById("oma-myyja")) {
  const element = document.getElementById("oma-myyja");
  let props = {};
  if (element.dataset.industry) {
    props.industry = true;
  }
  createApp(App, props).use(store).use(i18n).mount("#oma-myyja");
}
if (getCurrentLocale() !== "sv") {
  // Kalkkilaskuri mounting logic
  if (document.getElementById("kalkkilaskuri")) {
    createApp(Laskuri).use(store).mount("#kalkkilaskuri");
  }

  // Myyjä/vaihde lift mounting logic
  if (document.getElementById("myyja-lift")) {
    const element = document.getElementById("myyja-lift");
    let props = {};
    if (element.dataset.twoColumn) {
      props.twoColumn = true;
    }
    if (element.dataset.extraText) {
      props.extraText = true;
    }
    if (element.dataset.showSearch) {
      props.showSearch = true;
    }
    createApp(SellerLiftApp, props).use(store).use(i18n).mount("#myyja-lift");
  }

  // Tuotepage mounting logic
  if (document.getElementById("tuote-page")) {
    debug("Tuote page found");
    const props = {};
    const url = new URL(window.location.href);
    const cleanPath = url.pathname.split("/").filter((s) => s.length > 0);
    debug(`cleanPath: ${cleanPath}`);
    if (cleanPath.includes("tuotekategoria")) props.category = cleanPath.pop();
    const element = document.getElementById("tuote-page");
    if (element?.dataset.products && element?.dataset.categories) {
      store.commit(SET_PRODUCTS, JSON.parse(element.dataset.products));
      const data = JSON.parse(element.dataset.categories);
      store.commit(SET_CATEGORIES, buildCategoryStructure(data));
      store.dispatch(UPDATE_DISTANCE);
    }
    if (url.searchParams.get("luomu") === "true")
      store.commit(UPDATE_ECO_FILTER, true);
    if (url.searchParams.get("talvi") === "true")
      store.commit(UPDATE_WINTER_FILTER, true);
    createApp(ProductPage, props).use(store).mount("#tuote-page");
  }

  if (document.getElementById("tuote-page-header")) {
    const element = document.getElementById("tuote-page-header");
    let props = {};
    if (element.dataset.title) {
      props.title = element.dataset.title;
    }
    if (element.dataset.src) {
      props.src = element.dataset.src;
    }
    createApp(ProductPageHeader, props).use(store).mount("#tuote-page-header");
  }
}
